// Vue plugin to handle expected Vue Router navigation errors
// This suppresses NavigationAborted and NavigationDuplicated errors which are
// expected when navigation guards prevent navigation
export default {
  install(Vue) {
    // Handle unhandled promise rejections from Vue Router
    window.addEventListener('unhandledrejection', event => {
      const err = event.reason
      // Ignore NavigationAborted and NavigationDuplicated errors from Vue Router
      // These are expected when navigation guards prevent navigation
      if (err && (
        err.name === 'NavigationAborted' || 
        err.name === 'NavigationDuplicated' ||
        (err.message && err.message.includes('Navigation aborted'))
      )) {
        event.preventDefault()
      }
    })
  }
}

